import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MONITOR_EMBARQUE_EXPORTADOR } from '../../../../config/tables'

function TablaMonitorPorExportador () {
  return (
    <MuiTable id={TABLA_MONITOR_EMBARQUE_EXPORTADOR} />
  )
}

export default TablaMonitorPorExportador
